// @flow

//import { IconMic, IconMicSlash } from '../../icons';
import {
    IconToolbarMicrophoneEmpty,
    IconToolbarMicrophoneEmptySlash,
} from "../../icons";

import AbstractButton from "./AbstractButton";
import type { Props } from "./AbstractButton";
 
/**
 * An abstract implementation of a button for toggling audio mute.
 */
export default class AbstractAudioMuteButton<
    P: Props,
    S: *
> extends AbstractButton<P, S> {
    icon = IconToolbarMicrophoneEmpty;
    toggledIcon = IconToolbarMicrophoneEmptySlash;

    buttonLabel = 'toolbar.buttonLabel.mute';
    accessibilityLabel = 'toolbar.accessibilityLabel.mute';
    label = 'toolbar.mute';
    tooltip = 'toolbar.mute';

    
    /**
     * Handles clicking / pressing the button, and toggles the audio mute state
     * accordingly.
     *
     * @override
     * @protected
     * @returns {void}
     * 
     * 
     */
    _handleClick() {
        //Below two lines added extra in oder to play sound when AudioMute Button is clicked
        const audio = new Audio('./sounds/audio-mute.mp3');
        audio.play();
        this._setAudioMuted(!this._isAudioMuted());
        this.buttonLabel = this._isAudioMuted() ? 'toolbar.buttonLabel.mute' : 'toolbar.buttonLabel.unmute';
        this.accessibilityLabel = this._isAudioMuted() ? 'toolbar.accessibilityLabel.afterunmute' : 'toolbar.accessibilityLabel.aftermute';  
    }

    /**
     * Helper function to be implemented by subclasses, which must return a
     * boolean value indicating if audio is muted or not.
     *
     * @protected
     * @returns {boolean}
     */
    _isAudioMuted() {
        // To be implemented by subclass.
    }

    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this._isAudioMuted();
    }

    /**
     * Helper function to perform the actual setting of the audio mute / unmute
     * action.
     *
     * @param {boolean} audioMuted - Whether audio should be muted or not.
     * @protected
     * @returns {void}
     */
    _setAudioMuted(audioMuted: boolean) {
        // eslint-disable-line no-unused-vars
        // To be implemented by subclass.
    }
}
